// TODO: Finish this component with unit testing of the Web PhoneOrEmailField
import { InputMask, MaskedDynamicOptions } from 'imask/esm/index';
import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { PhoneOrEmailFieldMaskProps } from '../FormPhoneOrEmailField.types';

/**
 * This would only be used in the web version, which is currently used nowhere.
 * Until unit testing occurs, this is not fully finished.
 */
export const PhoneOrEmailFieldMask = forwardRef<HTMLInputElement, PhoneOrEmailFieldMaskProps>(({
    isMasked,
    onChange,
    value,
    ...props
}, ref) => {
    // There is no web version so this is commented out until unit testing

    // const [inputValue, setInputValue] = useState<string>(value);

    /*
     * useEffect(() => {
     *     if (inputValue !== value) {
     *         setInputValue(value);
     *     }
     * }, [inputValue, value]);
     */

    return (
        <IMaskInput
            {...props}
            mask={[
                {
                    mask: isMasked ? '(XXX) XXX-0000' : '(#00) 000-0000',
                    definitions: {
                        X: {
                            mask: '0',
                            displayChar: '*',
                            placeholderChar: '#',
                        },
                        '#': /[1-9]/gu,
                    },
                },
                {
                    mask: /^\S*@?\S*$/,
                },
                {
                    mask: /.*/,
                },
            ]}
            inputRef={ref}
            value={value}
            onAccept={(value: string, maskRef: InputMask<MaskedDynamicOptions>, element: InputEvent | undefined) => {
                // There is no web version so this is commented out until unit testing

                /*
                 * if (maskRef.masked.currentMask && maskRef.masked.currentMask.mask === '(#00) 000-0000') {
                 *     console.log(value[value.length - 1], value);
                 *     if (value[value.length - 1] === '-') {
                 *         const newValue: string = value.slice(0, value.length - 1);
                 */

                /*
                 *         setInputValue(newValue);
                 *         onChange({ target: { value: maskRef.unmaskedValue } });
                 */

                /*
                 *         return;
                 *     }
                 *     if (value[value.length - 1] === ' ' && value[value.length - 2] === ')') {
                 *         const newValue: string = value.slice(0, value.length - 2);
                 */

                /*
                 *         setInputValue(newValue);
                 *         onChange({ target: { value: maskRef.unmaskedValue } });
                 */

                /*
                 *         return;
                 *     }
                 *     if (value[value.length - 1] === '(') {
                 *         console.log('here');
                 *         const newValue: string = '';
                 */

                /*
                 *         setInputValue(newValue);
                 *         onChange({ target: { value: maskRef.unmaskedValue } });
                 */

                /*
                 *         return;
                 *     }
                 * }
                 * console.log(value, maskRef);
                 */

                onChange({ target: { value: maskRef.unmaskedValue } });

                return;
            }}
        />
    );
});